import React from "react";
import { Card } from "./ui/card";
import { Star } from "lucide-react";
import { MOCK_TESTIMONIALS } from "../utils/mock";

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-16 sm:py-24 px-4 sm:px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Client Success Stories
          </h2>
          <p className="text-lg sm:text-xl text-slate-600 max-w-2xl mx-auto px-4">
            See how I've helped businesses achieve remarkable growth through strategic SEO and digital marketing
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          {MOCK_TESTIMONIALS.map((testimonial, index) => (
            <Card
              key={index}
              className="p-8 border-slate-200 hover:shadow-xl transition-all duration-300 bg-white"
            >
              <div className="flex gap-1 mb-6">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-amber-400 text-amber-400"
                  />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed mb-6 italic">
                "{testimonial.content}"
              </p>
              <div className="border-t border-slate-200 pt-6">
                <p className="font-bold text-slate-900">{testimonial.name}</p>
                <p className="text-sm text-slate-600">{testimonial.role}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;